import { backgroundTaskStateEntityName } from '../shared/entityTypes';
export function getBackgroundTaskStateStorage(context) {
    return context.storage(backgroundTaskStateEntityName);
}
